export const CcqArcModes = { SPINNER: 'spinner', PROGRESS: 'progress', DONE: 'done' } as const

export type CcqArcMode = (typeof CcqArcModes)[keyof typeof CcqArcModes]
